import { render, staticRenderFns } from "./ProductCategoryVerticalSelect.vue?vue&type=template&id=56ed7ec0&scoped=true&"
import script from "./ProductCategoryVerticalSelect.vue?vue&type=script&lang=js&"
export * from "./ProductCategoryVerticalSelect.vue?vue&type=script&lang=js&"
import style0 from "./ProductCategoryVerticalSelect.vue?vue&type=style&index=0&lang=less&"
import style1 from "./ProductCategoryVerticalSelect.vue?vue&type=style&index=1&id=56ed7ec0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ed7ec0",
  null
  
)

export default component.exports